/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_OverlineInputs */

const en_mk_agent_overline = /** @type {(inputs: Mk_Agent_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The difference`)
};

const id_mk_agent_overline = /** @type {(inputs: Mk_Agent_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang membedakan`)
};

/**
* | output |
* | --- |
* | "The difference" |
*
* @param {Mk_Agent_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_overline = /** @type {((inputs?: Mk_Agent_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_overline(inputs)
	return en_mk_agent_overline(inputs)
});